import { render, staticRenderFns } from "./LuConcernDialog.vue?vue&type=template&id=0e5a5763"
import script from "./LuConcernDialog.vue?vue&type=script&lang=js"
export * from "./LuConcernDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports